import { FC } from 'react';
import { useIntl } from 'react-intl';
import CheckmarkAnimation from './ConfirmedActionEffect';

type ConfirmedActionModalProps = {
    show: boolean;
    message: string;
    data?: string | undefined;
};

const ConfirmedActionModal: FC<ConfirmedActionModalProps> = ({ show, message, data = undefined }) => {
    const intl = useIntl();
    if (!show) return null;

    return (
        <>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
                <div className='modal-dialog modal-dialog-centered modal-md'>
                    <div className='modal-content'>
                        <div className='modal-body'>
                            <div className='d-flex justify-content-center'><CheckmarkAnimation /></div>
                            <h5 className='text-center'>{intl.formatMessage({ id: message })}</h5>
                            {data ? (
                                <h5 className='text-center'>{`${intl.formatMessage({ id: 'LABEL.NAME' })} : ${data}`}</h5>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    );
};

export default ConfirmedActionModal;
